module.exports = __webpack_public_path__ + "static/img/zqys-1.f6303da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zqys/zqys-1.png
// module id = 231
// module chunks = 6